import { createContext, useContext } from "react";

export interface PaginationContextProps {
  page: number;
  pageCount: number;
  total: number;
  pages: number;
  activePage?: number;
  range: (string | number)[] | number[][] | undefined;
  setPage?: (page: number) => void;
  setPageCount?: (page: number) => void;
}

export const PaginationContext = createContext<PaginationContextProps>(
  {} as PaginationContextProps
);

export function usePaginationContext() {
  return useContext(PaginationContext);
}
